import { ReactElement } from 'react';
import {
  ImageSt,
  SectionContainerSt,
  SectionContentSt,
  SectionHeadingSt,
} from './ReviewSection.css';
import { DangerousElement } from 'app/shared/components/DangerousElement/DangerousElement';

interface Section {
  heading: string;
  content: string;
}

interface MainSection extends Section {
  summary?: string;
  image?: string;
}

export interface IReviewSectionProps {
  slug: string;
  mainSection: MainSection;
  additionalSections: Section[];
  showMainHeading?: boolean;
}

const ReviewSection = ({
  slug,
  mainSection,
  additionalSections,
  showMainHeading = true,
}: IReviewSectionProps): ReactElement => {
  return (
    <SectionContainerSt>
      {showMainHeading && (
        <SectionHeadingSt id={slug} as={'h2'} level={2}>
          {mainSection.heading}
        </SectionHeadingSt>
      )}
      <SectionContentSt>
        {mainSection.image ? <ImageSt src={mainSection.image} /> : null}
        {mainSection.summary ? <b>{mainSection.summary}</b> : null}
        <DangerousElement html={mainSection.content} />
      </SectionContentSt>
      {additionalSections.map(s => (
        <div key={s.heading}>
          <SectionHeadingSt as={'h3'} level={3}>
            {s.heading}
          </SectionHeadingSt>
          <SectionContentSt>
            <DangerousElement html={s.content} />
          </SectionContentSt>
        </div>
      ))}
    </SectionContainerSt>
  );
};

export default ReviewSection;
